/**
 * @bref    Fonctionnalitées jQuery relatives au formulaire des Clients.
 * @remark  Fichier appelé dans un bloc jQuery.
 */
require('../functions/AppAjax.class');
let AppAjax = window.AppAjax;

//#####################################################
// Mise à jour de la liste des utilisateurs d'un client
//#####################################################
$('select[name=client_id]').on('change', function(event) {
    // Protection contre les cliqueurs intempestifs !
    event.stopPropagation();

    // Récupération du pays sélectionné
    let client_id = $(this).find('option:selected').val();
    if (client_id) {
        // Mise à jour de la liste des Membres du Client sélectionné
        AppAjax.updateSelectOptions('select[name=contact_id]', 'contacts', {
            client_id: client_id,
            render: 'list'
        }, undefined, 'loading');
    } else {
        // Vidage du champ
        AppAjax.clearSelectOptions('select[name=contact_id]');
    }
});
